export default process.env.NODE_ENV === 'production' ? 'https://share.verdedata.ro' : 'http://localhost:15555'
